import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReminderResponse } from "../../Models/dashboard.model";
import { MatIconModule } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TodayOrOtherDatePipe } from "../../../../modules/shared/Pipes/today-or-other-date.pipe";

@Component({
    selector: "app-dash-reminder-card",
    templateUrl: "./dash-reminder-card.component.html",
    styleUrls: ["./dash-reminder-card.component.scss"],
    imports: [MatIconModule, NgIf, MatTooltipModule, TodayOrOtherDatePipe]
})
export class DashReminderCardComponent {
    @Input() reminderData: ReminderResponse;
    @Output() markAsDoneEvent = new EventEmitter<ReminderResponse>();
    @Output() viewReminderEvent = new EventEmitter<ReminderResponse>();

    ngOnChanges() {
        if (this.reminderData) {
            this.reminderData = new ReminderResponse(this.reminderData);
        }
    }

    markAsDone($event: MouseEvent) {
        $event.stopPropagation();
        this.markAsDoneEvent.emit(this.reminderData);
    }

    viewReminder() {
        this.viewReminderEvent.emit(this.reminderData);
    }
}
